<template>
  <div
    v-for="(group, position) in toastsByPosition"
    :key="position"
    :class="['zs-toast-container', position]"
  >
    <ZSToast v-for="toast in group" :key="toast.id" :toast="toast" @close="remove(toast.id)" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ZSToast from './ZSToast.vue';
import { useZSToast } from './useToast';

const { toasts, remove } = useZSToast();

const toastsByPosition = computed(() => {
  const groups = {};
  toasts.value.forEach((toast) => {
    const position = toast.position || 'tr';
    if (!groups[position]) {
      groups[position] = [];
    }
    groups[position].push(toast);
  });
  return groups;
});
</script>

<style scoped>
.zs-toast-container {
  position: fixed;
  z-index: 200000002;
  width: 350px;
  /* pointer-events: none; */
}

.zs-toast-container.tl {
  top: 1rem;
  left: 1rem;
}
.zs-toast-container.tc {
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.zs-toast-container.tr {
  top: 1rem;
  right: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.zs-toast-container.bl {
  bottom: 1rem;
  left: 1rem;
}
.zs-toast-container.bc {
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.zs-toast-container.br {
  bottom: 1rem;
  right: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.zs-toast-container.cl {
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
}
.zs-toast-container.c {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.zs-toast-container.cr {
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>
